import { rem, Button } from '@vimeo/bokeh';
import { createInteractionDomName } from '@vimeo/cloud-live/libs/shared/utils/dom/identifying';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { EInteractionAuthOption } from '@vimeo/live-core/types/interaction_room';

import { VimeoUserLogin } from './VimeoUserLogin';

/**
 * Login as vimeo user button form.
 */
export function VimeoLogin({ id = createInteractionDomName('vimeo-login') }: IBaseDomElementProps) {
  return (
    <VimeoUserLogin
      id={id}
      loginType={EInteractionAuthOption.VIMEO}
      buttonRenderer={({ label, ...props }) => (
        <Button size={'md'} variant={'secondary'} marginTop={rem(8)} {...props}>
          {label}
        </Button>
      )}
    />
  );
}
